export enum PermissionStatus {
  ACCESS = 'ACCESS', // User has access
  MAINTENANCE = 'MAINTENANCE', // The API is in maintenance mode, can not resolve permission
  NO_ACCESS = 'NO_ACCESS', // User has no access
  UNDER_DEVELOPMENT = 'UNDER_DEVELOPMENT', // Module being developed, no permissions available
  UNRESOLVED = 'UNRESOLVED', // Could not resolve permissions
  NOT_EMPLOYEE_OR_MEMBER = 'NOT_EMPLOYEE_OR_MEMBER', // User not employee or member and should not have permission to anything
}
